import { render, staticRenderFns } from "./actMaleRecords.vue?vue&type=template&id=4b490ead&scoped=true"
import script from "./actMaleRecords.vue?vue&type=script&lang=js"
export * from "./actMaleRecords.vue?vue&type=script&lang=js"
import style0 from "./actMaleRecords.vue?vue&type=style&index=0&id=4b490ead&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b490ead",
  null
  
)

export default component.exports